<template>
  <div class="pb-selector" @click="mousedownHandler">
    <pb-input
      v-model="label"
      readOnly
      selector
      :size="size"
      :disabled="disabled"
      :placeholder="placeholder"
      :subTitle="subTitle"
    />

    <div class="pb-selector__op" :layout-visible="visible">
      <ul>
        <li
          class="pb-selector__op-item"
          v-for="(option, index) in options"
          :key="index.toString()"
          @click="selectHandler(option)"
        >
          {{ option[isLabel] }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { isEmpty } from "@/lib/utils";
export default {
  name: "PbSelector",
  data: () => ({
    visible: false,
    event: {
      current: null,
    },
  }),
  props: {
    size: {
      type: String, // "small" | "default" | "large",
      default: () => "default",
    },
    returnType: {
      type: String,
      default: () => "value",
    },
    isLabel: {
      type: String,
      default: () => "label",
    },
    value: [Number, String],
    placeholder: String,
    options: Array,
    disabled: Boolean,
    subTitle: String,
  },
  computed: {
    label() {
      // value 가 없으면 null 반환
      if (isEmpty(this.value)) return null;

      let isAll = this.returnType !== "all";

      const item = this.options.filter((f) => {
        const key = isAll ? this.returnType : this.isLabel;
        const compareTarget = isAll ? this.value : this.value[this.isLabel];

        return f[key] === compareTarget;
      })[0];

      if (!item) return null;

      return item[this.isLabel];
    },
  },
  methods: {
    addEvent() {
      if (!this.event.current) {
        this.event.current = () => {
          if (this.visible) this.hide();
        };
      }

      document.addEventListener("click", this.event.current);
    },

    removeEvent() {
      if (this.event.current) {
        document.removeEventListener("click", this.event.current);
        this.event.current = null;
      }
    },

    show() {
      this.visible = true;

      setTimeout(() => {
        this.addEvent();
      }, 0);
    },

    hide() {
      this.visible = false;
      this.removeEvent();
    },

    mousedownHandler() {
      if (this.disabled) {
        return;
      }

      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
    },

    selectHandler(option) {
      if (this.returnType === "all") {
        this.$emit("input", option);
        return;
      }

      this.$emit("input", option[this.returnType]);
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="scss">
.pb-selector {
  position: relative;

  input {
    cursor: pointer;
  }

  &__op {
    position: absolute;
    z-index: 1000;
    width: 100%;
    left: 0;
    top: 100%;
    transform: translateY(18px);
    transition: all 0.25s;
    opacity: 0;
    visibility: hidden;
    font-size: 1.35rem !important;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 3px 6px 0px rgba(0, 0, 0, 0.08);

    ul {
      padding-top: 0.8rem;
      padding-bottom: 0.8rem;
      max-height: 250px;
      overflow: auto;
    }

    &-item {
      height: 46px;
      line-height: 46px;
      padding: 0 24px;
      cursor: pointer;

      &:hover {
        background-color: #f7f7f7;
      }
    }

    &[layout-visible="true"] {
      transform: translateY(8px);
      opacity: 1;
      visibility: visible;
    }
  }
}
</style>
